import React from "react";
import { AuthState, EAuthStatus } from "../types/auth.type";
import { initialUser } from "../types/user.type";
import { initialEmployee } from "../types/employee.type";

type IContext = {
	auth: AuthState;
	isLoading: boolean;
	setAuth: React.Dispatch<React.SetStateAction<AuthState>>;
	setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

const AuthContext = React.createContext<IContext>({
	auth: {
		status: EAuthStatus.LOGGED_OUT,
		user: initialUser,
		employees: [initialEmployee],
		employeeId: "",
		officeId: "",
		roles: [],
		currentPosition: "",
	},
	isLoading: false,
	setAuth: () => {},
	setIsLoading: () => {},
});

export default AuthContext;
